import type { DocumentRevision } from '@/entities/Document';
import type { ApiResponse } from '@/shared/lib';
import api from '@/shared/api';
import type { AxiosResponse } from 'axios';

class VerificationApi {
  async getAwaitingVerification(): Promise<DocumentRevision[]> {
    try {
      const response = await api.get('/document-revisions/awaiting-verification');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching verifications:', error);
      throw error;
    }
  }

  /**
   * A decisão é um recurso do próprio Registro, criada em `/matrices/:id/verification`. A data de
   * início de vigência é data civil e vai como AAAA-MM-DD.
   */
  async createMatrixVerification({
    matrixId,
    ...decision
  }: {
    matrixId: number;
    status: 'VERIFIED' | 'REJECTED';
    positionId?: number;
    effectiveDate?: string;
    justification?: string;
  }): Promise<AxiosResponse<ApiResponse<any>>> {
    return api.post<ApiResponse<any>>(`/matrices/${matrixId}/verification`, decision);
  }

  async createVerification(data: {
    documentRevisionId: number;
    approved: boolean;
    positionId?: number;
    justification?: string;
    approvalId?: number;
    effectiveDate?: string;
  }): Promise<AxiosResponse<ApiResponse<any>>> {
    try {
      const response = await api.post<ApiResponse<any>>('/document-verifications', data);
      return response;
    } catch (error) {
      console.error('Error creating verification:', error);
      throw error;
    }
  }
}

export const verificationApi = new VerificationApi();
